import { Suspense, lazy } from 'react';
// components
import LoadingScreen from '../components/loading-screen';

// ----------------------------------------------------------------------

const Loadable = (Component) => (props) =>
  (
    <Suspense fallback={<LoadingScreen />}>
      <Component {...props} />
    </Suspense>
  );

// ----------------------------------------------------------------------

// AUTH
export const ClientLoginPage = Loadable(lazy(() => import('../pages/auth/client/LoginPage')));

// DASHBOARD: CLIENT
export const DashboardPage = Loadable(lazy(() => import('../pages/client/DashboardPage')));
export const RequestListPage = Loadable(lazy(() => import('../pages/client/RequestListPage')));
export const RequestNewPage = Loadable(lazy(() => import('../pages/client/RequestNewPage')));
export const RequestViewPage = Loadable(lazy(() => import('../pages/client/RequestViewPage')));
export const UserAccountPage = Loadable(lazy(() => import('../pages/client/UserAccountPage')));
export const RequestCompletedPage = Loadable(
  lazy(() => import('../pages/client/FatturazionePage'))
);

// MAIN

export const Page404 = Loadable(lazy(() => import('../pages/Page404')));
export const HomePage = Loadable(lazy(() => import('../pages/HomePage')));
export const ComingSoonPage = Loadable(lazy(() => import('../pages/ComingSoonPage')));
